import { graphql } from "../../gql";

export const pingLastLoginMutation = graphql(/*GraphQL*/ `
  mutation PingLastLogin {
    pingLastLogin {
      success
    }
  }
`);
